var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"prop-list-row",class:{ flash: _vm.flash },attrs:{"dense":""}},[_c('v-col',{staticClass:"prop-key"},[_vm._v(_vm._s(_vm.name))]),_c('v-col',{staticClass:"prop-value"},[_vm._v(_vm._s(_vm.timeAgo))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }